<!--app管理-->
<template>
    <div>
        <!--顶部搜索-->
        <el-row :gutter="20">
            <el-form :size="size" label-width="80px">
                <el-col :span="4">
                    <el-form-item label="类型：" >
                        <el-select v-model="queryInfo.phoneType" placeholder="请选择" clearable>
                            <el-option
                                    v-for="item in types"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2" >
                    <el-button :size="size" v-permission="['SYS-APP-PAGE']" type="primary" @click="handleQuery">搜索</el-button>
                </el-col>
                <el-col :span="18" style="text-align: right;">
                    <!--icon="el-icon-plus" -->
                    <el-button :size="size" v-permission="['SYS-APP-ADD']" type="primary" @click="showAddDialog">添加</el-button>
                </el-col>
            </el-form>
        </el-row>
        <!--内容展示-->
        <el-row style="">
            <el-table v-loading="loading" ref="tableRef" border stripe :height="treeTableHeight" :data="tablelist" >
                <template v-for="(v,k) in columns">
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.label==='操作'">
                        <template slot-scope="scope">
                            <el-button v-permission="['SYS-APP-UPDATE']" type="primary" size="mini" icon="el-icon-edit" round @click="showEditDialog(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='isForce'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isForce===true">是</span>
                            <span v-else >否</span>
                        </template>
                    </el-table-column>
                    <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                </template>
            </el-table>
            <!--分页区域-->
            <Pagination v-show="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
        </el-row>
        <el-dialog :title="titleForm"
                   width="50%"
                   @close="handleClose"
                   :visible.sync="editDialogVisible"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :destroy-on-close="true">
            <el-form :model="editItem" :rules="formRules" ref="editFormRef" label-width="120px">
                <el-row >
                    <el-col :span="12">
                        <el-form-item label="版本号：" prop="versionName">
                            <el-input v-model="editItem.versionName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="版本代码：" prop="versionCode">
                            <el-input v-model="editItem.versionCode"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="类型：" prop="phoneType">
                            <el-select v-model="editItem.phoneType" placeholder="请选择" style="width: 100%;">
                                <el-option
                                        v-for="item in types"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="描述：" prop="description">
                            <el-input v-model="editItem.description"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发布日期：" prop="publishDate">
                            <el-date-picker style="width: 100%;"
                                    v-model="editItem.publishDate"
                                    align="right"
                                    type="date"
                                    placeholder="选择日期"
                                    :picker-options="pickerOptions"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="上传安排app：" prop="">
                            <el-upload
                                    class="avatar-uploader"
                                    :class="{hide:hideUploadIcon}"
                                    ref="upload"
                                    :action="''"
                                    :multiple="false"
                                    :on-preview="handlePreview"
                                    :on-change="onchange"

                                    :show-file-list="false"
                                    :auto-upload="false">
                                <i class="el-icon-plus"></i>
                                <span v-if="filename!=null&&filename!=''">{{filename}}</span>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="强制更新：" prop="isForce">
                            <el-select v-model="editItem.isForce" placeholder="请选择" style="width: 100%;">
                                <el-option
                                        v-for="item in forces"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addFun" v-loading.fullscreen="uploading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from '@/components/pagination/index'
    import {appAdd, appPage, appEdit} from '@/api/app'
    import {timeFormat} from "@/utils/common";
    export default {
        name: 'SYS-APP',
        components: {Pagination},
        data(){
            return {
                types: [
                    {value: 'android', label: 'Android'},
                    {value: 'ios', label: 'IOS'}
                ],
                forces: [
                    {value: true, label: '是'},
                    {value: false, label: '否'}
                ],
                tablelist: [],
                columns: [
                    {
                        label: '版本号',
                        prop: 'versionName',
                        fixed: 'left',
                        width: '100px'
                    },{
                        label: '类型',
                        prop: 'phoneType',
                        width: '100px'
                    },{
                        label: '版本代码',
                        prop: 'versionCode',
                        width: '100px'
                    },{
                        label: '发布日期',
                        prop: 'publishDate',
                        width: '180px'
                    },{
                        label: '修改描述',
                        prop: 'description',
                    },{
                        label: '强制更新',
                        prop: 'isForce',
                        width: '80px'
                    },{
                        label: '下载地址',
                        prop: 'downloadUrl',
                    },{
                        label: '操作',
                        type: 'template',
                        template: 'action',
                        width: '100px',
                        fixed: 'right'
                    }
                ],
                total: 0,
                queryInfo: {
                    pagesize: 10,
                    pagenum: 1,
                    phoneType: null
                },
                editItem: {
                    phoneType:'android',
                    isForce: false,
                    publishDate: timeFormat(new Date())
                },
                titleForm: '',
                editDialogVisible: false,
                size:this.COMMON.size,
                treeTableHeight:650,
                formRules:{
                    versionName:[
                        { required: true, message: '请输入版本名称', trigger: 'blur' }
                    ],
                    versionCode:[
                        { required: true, message: '请输入版本代码', trigger: 'blur' }
                    ],
                    publishDate:[
                        { required: true, message: '请输入选择发布日期', trigger: 'blur' }
                    ],
                    description:[
                        { required: true, message: '请输入描述信息', trigger: 'blur' }
                    ],
                    phoneType:[
                        { required: true, message: '请选择类型', trigger: 'blur' }
                    ]
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                hideUploadIcon:true,
                filename:null,
                file:null,
                loading: true,
                uploading: false
            }
        },
        methods:{
            getHeight() {
                if(this.total>0){
                    this.treeTableHeight = window.innerHeight - 60 -55 -40 -62 -32 + 'px'
                }else{
                    this.treeTableHeight = window.innerHeight - 60 -55 -40 -62 + 'px'
                }
            },
            handleClose() {
                this.$nextTick(() => {
                    this.editItem = {
                        phoneType: 'android',
                        isForce: false,
                        publishDate: timeFormat(new Date())
                    } // 给表单赋值
                    this.file=null
                    this.filename = ''
                })
                this.editDialogVisible = false
            },
            showAddDialog() {
                this.titleForm = '添加'
                this.editDialogVisible = true
            },
            showEditDialog(item) {
                this.editItem = JSON.parse(JSON.stringify(item))
                this.titleForm = '编辑'
                this.editDialogVisible = true
            },
            init(){
                let param = {}
                param.current = this.queryInfo.pagenum
                param.size = this.queryInfo.pagesize
                this.loading = true
                appPage(param,this.queryInfo).then(response => {
                    if(response.code!=200)  return this.$message.error(response.msg)
                    this.tablelist = response.data.records
                    this.total = response.data.total
                    this.getHeight()
                    this.loading = false
                })
            },
            /**
             * 分页组件切换分页大小事件处理
             * @param newSize
             */
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize
                this.init()
            },
            /**
             * 分页组件切换页事件处理
             * @param newPage
             */
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage
                this.init()
            },
            handlePreview(file) {
                console.log(file)
            },
            onchange(file,fileList){
                console.log(file,fileList)
                this.file=file.raw
                this.filename=file.name
                console.log(this.param)
            },
            addFun(){
                this.$refs.editFormRef.validate(async valid => {
                    if (!valid) return
                    this.param = new FormData()
                    if(this.file){
                        this.param.append('file',this.file)
                    }
                    this.param.append('versionName',this.editItem.versionName)
                    this.param.append('versionCode',this.editItem.versionCode)
                    this.param.append('phoneType', this.editItem.phoneType)
                    this.param.append('description', this.editItem.description)
                    this.param.append('publishDate', this.editItem.publishDate)
                    this.param.append('isForce', this.editItem.isForce)
                    this.uploading=true
                    /*const uploading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.3)'
                    });*/
                    if(this.titleForm==='添加'){
                        appAdd(this.param).then(response => {
                            if(response.code!=200){
                                return this.$message.error(response.msg)
                            }
                            this.$message.success('添加app成功！')
                            this.init()
                            this.uploading=false
                            //uploading.close()
                            this.editDialogVisible = false
                        })
                    }else{
                        this.param.append('id', this.editItem.id)
                        this.param.append('downloadUrl', this.editItem.downloadUrl)
                        appEdit(this.param).then(response => {
                            if(response.code!=200){
                                return this.$message.error(response.msg)
                            }
                            this.$message.success('更新app成功！')
                            this.init()
                            this.uploading=false
                            //uploading.close()
                            this.editDialogVisible = false
                        })
                    }
                })
            },
            /** 搜索按钮操作 */
            handleQuery() {
                this.queryInfo.pagenum=1
                this.init()
            }
        },
        created(){
            this.init()
            window.addEventListener('resize', this.getHeight)
        },
        activated(){
            this.$refs.tableRef.doLayout()
        }
    }
</script>

<style scoped>
    .avatar-uploader >>>.el-upload--picture-card{
        width: 80px!important;
        height: 80px!important;
        line-height: 80px!important;
    }
</style>
